<template>
  <div class="animated fadeIn">
    <b-card style="min-height: 300px">
      <b-form @submit.stop.prevent="onSubmit">

        <div class="animated fadeIn">

          <b-row>
            <b-col cols="auto" class="mr-auto">
            
            </b-col>
            <b-col cols="auto" class="">
              <b-form-group>
                <b-button variant="github" class="mr-1 btn-brand" @click="openAddressModal(null)" v-show="selectedItem.id && selectedItem.id > 0"><i class="fa fa-plus"></i><span>Novo Endereço</span></b-button>
              </b-form-group>
            </b-col>
          </b-row>
             
          <b-card header="Principal" v-for="address in selectedItem.addresses" :key="address.id">

            <p>
            {{ address.address  }}, {{ address.addressNumber }}<br>
            {{ address.complement }}<br>
            {{ address.district }}<br>
            {{ address.city }} - {{ address.stateCode }} - {{ address.country }}<br>
            CEP: {{ address.zipCode }}</p>

            <p><span class="small">{{ address.notes }}</span></p>

            <div class="text-right">
              <b-button variant="danger" class="mr-1 btn-brand" @click="deleteAddress(address)"><i class="fa fa-close"></i><span>Excluir</span></b-button>
              &nbsp;
              <b-button variant="primary" class="mr-1 btn-brand"  @click="openAddressModal(address)"><i class="fa fa-edit"></i><span>Editar</span></b-button>
            </div>
          </b-card>

        </div>
      </b-form>
    </b-card>


    <b-modal
            v-model="addressModal"
            id="address-modal"
            centered
            hide-footer
            title="Endereço"
            size="lg"
            >
        
        <b-card>   

            <b-form @submit.stop.prevent="onSubmit">
            <div class="animated fadeIn">
              <b-row>
                  <b-col md="12">
                    
                    <b-form>
                      <b-form-group
                      description=""
                      label="Tipo de endereço"
                      label-for="addressType"
                      :label-cols="3"
                      :horizontal="true">


                      <b-row>
                        <b-col>
                          <b-form-select id="addressType"
                          v-model="selectedAddress.addressTypeId"
                          :plain="true"
                          :options="addressTypeDDL"
                          value="">
                        </b-form-select>
                        </b-col>

                      </b-row>
                      
                    </b-form-group>          
                    </b-form>
                  </b-col>
                </b-row>

                
              <b-row>
                    <b-col md="12">
                      
                      <b-form>
                        <b-form-group
                        description=""
                        label="Endereço"
                        label-for="address"
                        :label-cols="3"
                        :horizontal="true">
                          <b-row>
                            <b-col cols="7">
                              <b-form-input v-model="selectedAddress.address" id="address" type="text" :class="addressClass"></b-form-input>
                            </b-col>
                            <b-col cols="2">
                              Número:
                            </b-col>
                            <b-col cols="3">
                              <b-form-input v-model="selectedAddress.addressNumber" id="address_number" type="text"></b-form-input>
                            </b-col>
                          </b-row>
                      </b-form-group>          
                      </b-form>
                    </b-col>
                   
                  </b-row>

                  
                  <b-row>
                    <b-col md="12">
                      
                      <b-form>
                        <b-form-group
                        description=""
                        label="Complemento"
                        label-for="complement"
                        :label-cols="3"
                        :horizontal="true">
                          <b-row>
                            <b-col>
                              <b-form-input v-model="selectedAddress.complement" id="complement" type="text"></b-form-input>
                            </b-col>
                            <b-col cols="12" md="auto">
                              Bairro:
                            </b-col>
                            <b-col>
                              <b-form-input v-model="selectedAddress.district" id="district" type="text"></b-form-input>
                            </b-col>
                          </b-row>
                      </b-form-group>          
                      </b-form>
                    </b-col>
                   
                  </b-row>

                  <b-row>
                    <b-col md="12">
                      
                      <b-form>
                        <b-form-group
                        description=""
                        label="CEP"
                        label-for="zipCode"
                        :label-cols="3"
                        :horizontal="true">
                          <b-row>
                            <b-col cols="5">
                              <b-form-group>
                                <b-input-group style="width: 210px">
                                    <b-input-group-append><b-input-group-text><i class="fa fa-inbox"></i></b-input-group-text></b-input-group-append>
                                    <masked-input
                                      type="text"
                                      name="doc"
                                      class="form-control cols-md-2"
                                      v-model="selectedAddress.zipCode"
                                      :mask="[/\d/, /\d/, '.', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/]"
                                      :guide="false"
                                      placeholderChar="#"
                                      v-on:keyup="getZipCode(selectedAddress.zipCode)"
                                      >
                                    </masked-input>
                                  </b-input-group>
                                </b-form-group>          
                            </b-col>
                          </b-row>
                      </b-form-group>          
                      </b-form>
                    </b-col>                   
                  </b-row>

                  <b-row>
                    <b-col md="12">
                      
                      <b-form>
                        <b-form-group
                        description=""
                        label="Cidade"
                        label-for="city"
                        :label-cols="3"
                        :horizontal="true">


                        <b-row>
                          <b-col>
                            <b-form-select id="city"
                            v-model="selectedAddress.cityId"
                            :plain="true"
                            :options="this.cityDDL"
                            value="Cidade">
                          </b-form-select>
                          </b-col>
                          <b-col cols="12" md="auto">
                            Estado
                          </b-col>
                          <b-col>
                            <b-form-select id="state"
                              v-model="selectedAddress.stateId"
                              :plain="true"
                              :options="this.stateDDL"
                              value="Estado">
                            </b-form-select>
                          </b-col>
                        </b-row>
                        
                      </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>

                  <b-row>
                    <b-col md="12">
                      <b-form>
                        <b-form-group
                        description=""
                        label="Observação"
                        label-for="addressNotes"
                        :label-cols="3"
                        :horizontal="true">
                        <div>
                          
                          <b-form-textarea
                          id="addressNotes"
                          v-model="selectedAddress.notes"
                          placeholder=""
                          rows="3"
                          ></b-form-textarea>
                        </div>
                      </b-form-group>          
                      </b-form>
                    </b-col>
                  </b-row>


            </div>

            <div slot="footer" class="text-right">
                <b-button variant="github" class="mr-1 btn-brand" @click="save()"><i class="fa fa-check"></i><span>Salvar Endereço</span></b-button>
            </div>
            
            </b-form>            
        </b-card>

      </b-modal>

      <b-modal title="Excluir" class="modal-delete" v-model="deleteModal" @ok="deleteItem" cancel-title="Cancelar" >
          Deseja realmente excluir o endereço selecionado?
      </b-modal>
  </div>
</template>

<script>
import Vue from 'vue'
import axios from "axios";
import vSelect from 'vue-select'
import MaskedInput from 'vue-text-mask'

/* Toast */
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
//import { table } from 'console'
  
  const toastTypes = {
    success: 'success',
    error: 'error',
    info: 'info',
    warn: 'warn'
  }
  
  miniToastr.init({types: toastTypes})
  
  function toast ({title, message, type, timeout, cb}) {
    return miniToastr[type](message, title, timeout, cb)
  }
  
  const options = {
    success: toast,
    error: toast,
    info: toast,
    warn: toast
  }
  VueNotifications.setPluginOptions(options)
  
  Vue.use(VueNotifications, options)
  /* Toast - End */

  export default {
    name: 'PersonAddressComponent',
    props: {
       item: {}       
    },
    computed: {
        selectedItem() {
            return this.item
        }
    },
    components: {
      vSelect,
      MaskedInput,
    },
    data: () => {
        return {
          addressClass: "",
          selectedItemToDelete: null,
          deleteModal: false,
          addressModal: false,
          errorMessage: '',
          selectedAddress: {address: '', district: '', stateId: null, cityId: null},
          addressTypeDDL: [],
          stateDDL: [],
            cityDDL: [],

        }
    },
    methods: {
      async deleteItem() {
        var s = this
        var currentUser = this.$store.state.currentUser
        await axios.delete(
            this.$store.state.ws_url + "/person/address?id=" + this.selectedItemToDelete.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid            
        ).then(function(resp) {
          s.refreshData()
        }).catch(function (error) {
          console.log(error);
        })
      },
      deleteAddress(item) {
        this.selectedItemToDelete = item
        this.deleteModal = true
      },

      async saveItem() {
        var s = this
        var currentUser = this.$store.state.currentUser
        this.selectedAddress.uid = currentUser.id
        this.selectedAddress.sid = currentUser.sid
        
        await axios.post(
            this.$store.state.ws_url + "/person/address",
            this.selectedAddress
            
        ).then(function(resp) {
          s.addressModal = false
          s.refreshData()
        }).catch(function (error) {
          console.log(error);
        })

      },

      save() {
        var containsError = false
        if(this.selectedAddress.address.length <= 0) {
          this.addressClass = 'is-invalid'
          this.containsError = true
        }
        else {
          this.addressClass = ''
        }

        if(!containsError) {
          this.saveItem()
        }
        
        
      },

      async getZipCode(zipCode) {
        var s = this;
        var currentUser = this.$store.state.currentUser;
        zipCode = zipCode.replace(/\D/g, "");
      
        if(zipCode.length >= 8) {          
          await axios.get(
              this.$store.state.ws_url + "/utils/cep/" + zipCode
              
          ).then(function(resp) {
            s.selectedAddress.address = resp.data.obj.logradouro;
            s.selectedAddress.district = resp.data.obj.bairro;

            if(s.selectedAddress.stateId != resp.data.obj.stateId) {
              s.selectedAddress.stateId = resp.data.obj.stateId
              s.getCity(s.$store.state.config.countryId, resp.data.obj.stateId);
            }              
            s.selectedAddress.cityId = resp.data.obj.cityId
          }).catch(function (error) {
            console.log(error);
          })
        }

      },

      async getCity(countryId, stateId) {
        var s = this
        var currentUser = this.$store.state.currentUser

        if(!countryId) {
          countryId = this.$store.state.config.countryId
        }

        if(!stateId) {
          stateId = this.$store.state.config.stateId
        }

        await axios.get(
            this.$store.state.ws_url + "/city/ddl?countryId=" + countryId + "&stateId=" + stateId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            
        ).then(function(resp) {
          s.cityDDL = resp.data.obj;
        }).catch(function (error) {
          console.log(error);
        })
        
      },
      async getState(countryId) {
        var s = this
        var currentUser = this.$store.state.currentUser
        await axios.get(
            this.$store.state.ws_url + "/state/ddl?countryId=" + countryId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
            
        ).then(function(resp) {
          s.stateDDL = resp.data.obj;
        }).catch(function (error) {
          console.log(error);
        })
        
      },
      async getAddressType() {
        var s = this
        var currentUser = this.$store.state.currentUser
        await axios.get(
            this.$store.state.ws_url + "/person/address/type/ddl?uid=" + currentUser.id + "&sid=" + currentUser.sid
            
        ).then(function(resp) {
          s.addressTypeDDL = resp.data.obj;
        }).catch(function (error) {
          console.log(error);
        })
      },

      openAddressModal(item) {
        this.getAddressType();
       
        if(item == null) {
          this.selectedAddress.addressTypeId = 1;
          this.selectedAddress.personId = this.selectedItem.id;
          this.selectedAddress.stateId = this.$store.state.config.stateId;
          this.selectedAddress.address = ""
          this.selectedAddress.addressNumber = ""
          this.selectedAddress.district = ""
        }
        else {
          this.selectedAddress = item
        }

        this.getCity(this.$store.state.config.countryId, this.selectedAddress.stateId)
        if(!this.selectedAddress.cityId) {
          this.selectedAddress.cityId = this.$store.state.config.cityId;
        }

        this.addressModal = true;
      },

      async refreshData() {
        var s = this
        var currentUser = this.$store.state.currentUser
        await axios.get(
            this.$store.state.ws_url + "/person/address?personId=" + this.selectedItem.id + "&uid=" + currentUser.id + "&sid=" + currentUser.sid            
        ).then(function(resp) {
          s.selectedItem.addresses = resp.data.obj;
        }).catch(function (error) {
          console.log(error);
        })
      },
    },
    mounted: function() {
      this.getState(this.$store.state.config.countryId)
      this.refreshData()
    }
  }

</script>